import Table from "@/src/components/atom/Table";
import ExporterMainLayout from "@/src/components/template/Layout/exporter/ExporterMainLayout";
import useAgGridHeaderRefresh from "@/src/hooks/useAgGridHeaderRefresh";
import useFilterSearch from "@/src/hooks/useFilterSearch";
import EXPORTER_PRIVATE_PATH from "@/src/routes/exporter/path";
import { useLazyGetNoticesQuery } from "@/src/store/apis/notice";
import colorSet from "@/src/styles/color";
import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { styled } from "styled-components";
import { columnNoticeList } from "./columns/columnNoticeList";
import { useGetSessionQuery } from "@/src/store/apis/auth";

const ExporterNoticePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const gridRef = useRef<AgGridReact>(null);

  const [isReady, setIsReady] = useState(false);
  const [columnDefs] = useState<ColDef[]>(columnNoticeList);
  const [getNotices, noticesResult] = useLazyGetNoticesQuery();

  useGetSessionQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  const {
    state: { pagination },
    func: { onPaginationChange },
  } = useFilterSearch({
    isReady,
    gridRef: gridRef.current,
    fetch: getNotices,
    defaultFilterData: {},
  });

  useAgGridHeaderRefresh({
    gridRef: gridRef.current,
    isReady,
    headerSet: [
      {
        columnKey: "title",
        langKey: "notice:table.title",
      },
      {
        columnKey: "createdAt",
        langKey: "notice:table.registerDate",
      },
    ],
  });

  useEffect(() => {
    if (gridRef.current) {
      if (noticesResult.isFetching) {
        gridRef.current.api.showLoadingOverlay();
      }
    }
  }, [noticesResult.isFetching]);

  return (
    <ExporterMainLayout
      breadcrumb={[t("sideNav:notice")]}
      pageTitle={t("sideNav:notice")}
    >
      <Card>
        <Table
          ref={gridRef}
          onGridReady={() => setIsReady(true)}
          columnDefs={columnDefs}
          rowData={
            noticesResult.isSuccess ? noticesResult.currentData?.rows : []
          }
          totalPage={noticesResult?.currentData?.count}
          onRowClicked={({ data }) => {
            navigate(`${EXPORTER_PRIVATE_PATH.NOTICE}/${data.id}`);
          }}
          isPaginationDataMaping
          pageSize={pagination.pageSize}
          page={pagination.page}
          handlePaginationClick={(page, pageSize) =>
            onPaginationChange({ page, pageSize })
          }
        />
      </Card>
    </ExporterMainLayout>
  );
};

export default ExporterNoticePage;

const Card = styled.div`
  border-radius: 16px;
  background: ${colorSet.white};
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.05);
  padding: 8px;
`;
